import type { ReactElement, SVGProps } from 'react';

export interface SortIconProps extends SVGProps<SVGSVGElement> {
  direction?: 'ASC' | 'DESC';
}

export default function SortIcon({
  direction,
  ...props
}: SortIconProps): ReactElement {
  const upOpacity = direction === 'DESC' ? 0.3 : 1;
  const downOpacity = direction === 'ASC' ? 0.3 : 1;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.7172 2.86435C5.7172 2.77547 5.6817 2.69027 5.6186 2.62768L3.09193 0.101012C3.03144 0.0365609 2.94699 0 2.8586 0C2.77021 0 2.68576 0.0365609 2.62527 0.101012L0.0985994 2.62768C0.0354952 2.69027 0 2.77547 0 2.86435C0 2.95323 0.0354952 3.03842 0.0985994 3.10101L0.231933 3.23435C0.29465 3.29945 0.381542 3.33566 0.471933 3.33435H5.24527C5.33566 3.33566 5.42255 3.29945 5.48527 3.23435L5.6186 3.10101C5.6817 3.03842 5.7172 2.95323 5.7172 2.86435Z"
        fill="currentColor"
        opacity={upOpacity}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.47101C0 6.55989 0.0354952 6.64509 0.0985994 6.70768L2.62527 9.23435C2.68576 9.2988 2.77021 9.33536 2.8586 9.33536C2.94699 9.33536 3.03144 9.2988 3.09193 9.23435L5.6186 6.70768C5.6817 6.64509 5.7172 6.55989 5.7172 6.47101C5.7172 6.38213 5.6817 6.29693 5.6186 6.23435L5.48527 6.10101C5.42255 6.03591 5.33566 5.9997 5.24527 6.00101H0.471933C0.381542 5.9997 0.29465 6.03591 0.231933 6.10101L0.0985994 6.23435C0.0354952 6.29693 0 6.38213 0 6.47101Z"
        fill="currentColor"
        opacity={downOpacity}
      />
    </svg>
  );
}
